import React from 'react';
import { Tooltip } from 'react-tooltip';

import useTranslation from '@hooks/useTranslation';

import { type IDeactivated, getDeactivatedInfo } from '../../helpers/getDeactivatedInfo';

import style from './style.module.scss';

interface IProps {
  deactivated: IDeactivated;
}

const InactiveEquipmentLabel = ({ deactivated }: IProps) => {
  const { t } = useTranslation();
  const { activeTime, createdBy, deactivatedTime } = getDeactivatedInfo(deactivated);

  return (
    <>
      <div className={style.inactiveEquipmentLabel} data-tooltip-id="info-icon">
        {t('inactive')}
      </div>
      <Tooltip id="info-icon" className={style.tooltipLabel}>
        <span className={style.labelTitle}>{t('This equipment is not being monitored')}</span>
        <div className={style.separator} />
        <div className={style.tooltipDateRow}>
          <span className={style.dateRowLabel}>{t('Inactive on')}</span>
          <span className={style.dateRowValue}>{deactivatedTime}</span>
        </div>
        <div className={style.tooltipDateRow}>
          <span className={style.dateRowLabel}>{t('Deactivated by')}</span>
          <span className={style.dateRowValue}>{createdBy}</span>
        </div>
        {activeTime && (
          <div className={style.tooltipDateRow}>
            <span className={style.dateRowLabel}>{t('Active from')}</span>
            <span className={style.dateRowValue}>{activeTime}</span>
          </div>
        )}
      </Tooltip>
    </>
  );
};

export default InactiveEquipmentLabel;
